import { enhanceDate, monthOptions } from '../enhance/dates';

const addMonths = (date, count) => new Date(new Date(date).setMonth(date.getMonth() + count));
const addDays = (date, count) => new Date(new Date(date).setDate(date.getDate() + count));

// Subscription/AddSubscription and Subscription/Edit. Monthly subscriptions pick
// months and credit subscriptions pick days; the end always stays at least one
// step after the start. Pass `minStart` to stop dates before it being chosen
// (Add); without it, changing the end can pull the start back too (Edit).
export function subscriptionDates({ monthly, start, end, minStart = null }) {
  const startInput = document.getElementById('StartDate');
  const endInput = document.getElementById('EndDate');
  const refreshDate = document.getElementById('ddlRefreshDate');
  const step = monthly ? addMonths : addDays;
  const options = monthly ? monthOptions : () => ({});

  if (refreshDate) {
    refreshDate.style.display = monthly ? '' : 'none';
  }

  let startPicker;

  const endPicker = enhanceDate(endInput, {
    ...options(),
    defaultDate: end,
    minDate: minStart && step(minStart, 1),
    onChange: ([date]) => {
      const previous = date && step(date, -1);

      if (!minStart && previous && previous < startPicker.selectedDates[0]) {
        startPicker.setDate(previous);
      }
    },
  });

  startPicker = enhanceDate(startInput, {
    ...options(),
    defaultDate: start,
    minDate: minStart,
    onChange: ([date]) => {
      if (!date) {
        return;
      }

      // Move the end first: raising minDate past it would clear it.
      const next = step(date, 1);
      const current = endPicker.selectedDates[0];

      if (!current || next > current) {
        endPicker.setDate(next);
      }

      if (minStart) {
        endPicker.set('minDate', next);
      }
    },
  });
}
